import { TranslateExcelOrderBusiness } from '../../coreDomainsModule/translateExcelOrder';

/**
 * 発注エクセル取り込み/出力用のファクトリークラス
 */
export class TranslateExcelOrderBusinessFactory {
  /**
   * TranslateExcelOrderを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<TranslateExcelOrderBusiness> = {}): TranslateExcelOrderBusiness => {
    const translateExcelOrder: TranslateExcelOrderBusiness = {
      translateOrderBusinessId: initialData.translateOrderBusinessId ?? '',
      warehouseNumber: initialData.warehouseNumber ?? '',
      warehouse: initialData.warehouse ?? '',
      package: initialData.package ?? '',
      businessNumber: initialData.businessNumber ?? '',
      businessName: initialData.businessName ?? '',
      supplierNumber: initialData.supplierNumber ?? '',
      supplierName: initialData.supplierName ?? '',
      excelOrders: {},
    };
    return translateExcelOrder;
  };
}
